import languages from './src/azure/tts/languages.json'
import { LanguageItem } from './src/azure/tts/languageItem'

/**
 * 匯出 Azure 語言列表
 */
export type { LanguageItem } from './src/azure/tts/languageItem'

/**
 * Get the list of supported Azure languages
 * @return {LanguageItem[]}
 */
export const getSupportedAzureSTTLanguages = (): LanguageItem[] => languages as LanguageItem[]

/**
 * Get the list of supported Azure languages
 * @param langs {string[]} language codes
 * @return {LanguageItem[]}
 */
export const findLanguageItemsBySupportAzureSTT = (langs: string[]): LanguageItem[] =>
  getSupportedAzureSTTLanguages().filter(lang => langs.includes(lang.locale))

